<template>
  <div v-if="!loggedIn">
    <div class="auth">
      <div class="auth-overlay" style="display: block"></div>
      <div class="d-flex align-center-option min-vh-100 py-3 py-md-0">
        <div class="container auth-container">
          <div class="auth-card">
            <div class="row no-gutters">
              <div class="col-md-5 m-0">
                <!--<div class="auth-card-overlay"></div>-->
                <img
                  src="../assets/img/login.jpg"
                  alt="login"
                  class="auth-card-img"
                />
              </div>
              <div class="col-md-7">
                <div class="card-body">
                  <a href="https://freedom-vrn.ru/b2b">
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Закрыть"
                    ></button>
                  </a>
                  <div class="brand-wrapper mb-2">
                    <div class="logo d-block"></div>
                    <div class="mr-4 logo-swift"></div>
                  </div>

                  <div class="h3-rem mb-3">
                    Личный кабинет для юридических лиц
                  </div>
                  <p>Пожалуйста, авторизуйтесь</p>

                  <form class="login" @submit.prevent="login">
                    <div class="input-group mb-4">
                      <input
                        v-model="username"
                        required
                        type="text"
                        class="form-control input-text"
                        placeholder="учетное имя"
                      />
                    </div>
                    <div class="input-group mb-4">
                      <input
                        v-model="password"
                        required
                        :type="showPassword ? 'text' : 'password'"
                        class="form-control input-text"
                        placeholder="пароль"
                      />
                      <div class="input-group-append">
                        <span
                          class="input-group-text"
                          :title="
                            showPassword ? 'Скрыть пароль' : 'Показать пароль'
                          "
                          @click="showPassword = !showPassword"
                        >
                          <i
                            class="fa"
                            :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                          ></i>
                        </span>
                      </div>
                    </div>
                    <div class="input-group mb-4">
                      <div class="d-flex">
                        <input
                          type="checkbox"
                          id="rememberMe"
                          v-model="rememberMe"
                          class="checkbox-box"
                        />
                        <label for="rememberMe"
                          ><span>Запомнить меня</span></label
                        >
                      </div>
                      <!--<lk-checkbox
                        v-model="rememberMe"
                        id="rememberMe"
                        label="Запомнить меня"
                      ></lk-checkbox>-->
                    </div>
                    <button
                      @click="login"
                      class="btn btn-blue"
                      :disabled="isLoadingClientData"
                    >
                      Войти
                    </button>
                    <lk-button class="mt-4" color="green" @click="register"
                      >Зарегистрироваться</lk-button
                    >
                    <!-- submit нужен для отправки формы по enter -->
                    <input type="submit" style="display: none" />
                  </form>

                  <div
                    v-if="message"
                    class="mt-3 warning"
                    v-html="message"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import config from "../config.js";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      username: "",
      password: "",
      rememberMe: true,
      message: null,
      showPassword: false,
    };
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.go(-1);
    }
  },
  watch: {
    username() {
      this.message = null;
    },
    password() {
      this.message = null;
    },
  },
  computed: {
    ...mapState(["loginSuccess", "loginError", "token", "isLoadingClientData"]),
    ...mapGetters(["loggedIn", "client"]),
  },
  methods: {
    ...mapActions(["auth", "fetchClient"]),

    register() {
      this.$router.push("/register");
    },

    login() {
      let username = this.username.trim().toLowerCase();
      let password = this.password.trim();
      if (!username) {
        this.message = "Учетное имя не указано";
        return;
      }
      if (!password) {
        this.message = "Пароль не указан";
        return;
      }
      if (
        !_.every(
          password,
          (ch) => config.password.availableChars.indexOf(ch) >= 0,
        )
      ) {
        this.message = "Пароль содержит недопустимые символы";
        return;
      }
      this.auth({
        username,
        password,
        rememberMe: this.rememberMe,
      }).then(() => {
        // const action = () => { this.$router.replace(this.$route.query.redirect || '/') }
        if (this.loginSuccess) {
          if (this.rememberMe) {
            localStorage.token = this.token;
          } else {
            sessionStorage.token = this.token;
          }
          this.fetchClient().then(() => {
            if (this.client.clientGroup === undefined) {
              this.$router.replace("logout");
              this.message = `Авторизуйтесь, пожалуйста, на другом адресе: <a href="https://lk.freedom-vrn.ru/">https://lk.freedom-vrn.ru/</a>`;
            } else {
              this.$router.replace("/");
            }
          });
        } else {
          this.message = this.loginError;
        }
      });
    },
  },
};
</script>

<style></style>
